// extracted by mini-css-extract-plugin
module.exports = {"container":"printer_container__Kse7q","wrapper":"printer_wrapper__3VEXD"};